/* ============================================================
   Dr Snail Landing — vanilla GSAP portu
   Kaynak: drsnail-landing/src (SmoothScrollProvider, LoadingScreen,
   ProductScene ve ScrollEngine bileşenlerinin birebir portu).
   Bağımlılıklar (CDN, defer sırasıyla): gsap, ScrollTrigger, Lenis.
   ============================================================ */
(function () {
  "use strict";

  function init() {
    if (!window.gsap || !window.ScrollTrigger) return;
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    gsap.registerPlugin(ScrollTrigger);

    var q = function (selector) {
      return document.querySelector(selector);
    };

    var prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    /* ---- Loading curtain: markası gösterip 0.9 sn sonra çekilir ---- */
    var curtain = q("[data-ds-loading]");
    if (curtain) {
      setTimeout(function () {
        gsap.to(curtain, {
          autoAlpha: 0,
          duration: 0.45,
          ease: "power1.out",
          onComplete: function () {
            curtain.remove();
          },
        });
      }, 900);
    }

    /* ---- Lenis: GSAP ticker'ına bağlı tek rAF döngüsü ---- */
    if (window.Lenis) {
      var lenis = new window.Lenis({
        duration: 1.15,
        smoothWheel: !prefersReduced,
        wheelMultiplier: 0.95,
        touchMultiplier: 1.4,
        anchors: { offset: 0 },
      });
      lenis.on("scroll", ScrollTrigger.update);
      gsap.ticker.add(function (time) {
        lenis.raf(time * 1000);
      });
      gsap.ticker.lagSmoothing(0);
    }

    /* ---- ProductScene kurulumu (idle yaşam belirtileri) ---- */
    var sceneRoot = q("[data-scene-root]");
    if (sceneRoot) {
      gsap.set(sceneRoot, { transformPerspective: 1000 });
      if (!prefersReduced) {
        gsap.to(q("[data-scene-glow]"), {
          scale: 1.07,
          opacity: 0.85,
          duration: 3.2,
          yoyo: true,
          repeat: -1,
          ease: "sine.inOut",
        });
        gsap.to(sceneRoot, {
          y: 9,
          duration: 4.4,
          yoyo: true,
          repeat: -1,
          ease: "sine.inOut",
        });
        gsap.to(q("[data-scene-shadow]"), {
          scale: 0.92,
          opacity: 0.72,
          duration: 4.4,
          yoyo: true,
          repeat: -1,
          ease: "sine.inOut",
        });
      }
    }

    /* ---- ScrollEngine: pinlenen hero + scrub açılış koreografisi ---- */
    ScrollTrigger.config({ ignoreMobileResize: true });

    var mm = gsap.matchMedia();

    mm.add("(prefers-reduced-motion: reduce)", function () {
      gsap.set("[data-hero-product], [data-hero-caption]", { autoAlpha: 1 });
    });

    mm.add(
      {
        desktop:
          "(min-width: 768px) and (prefers-reduced-motion: no-preference)",
        mobile:
          "(max-width: 767px) and (prefers-reduced-motion: no-preference)",
      },
      function (ctx) {
        var desktop = ctx.conditions.desktop;

        var hero = q("[data-hero]");
        var product = q("[data-hero-product]");
        var copy = q("[data-hero-copy]");
        var cue = q("[data-hero-cue]");
        var cueDot = q("[data-hero-cue-dot]");
        var sweep = q("[data-hero-sweep]");
        var lid = q("[data-scene-lid]");
        var glow = q("[data-scene-glow]");
        var shadow = q("[data-scene-shadow]");
        var reflection = q("[data-scene-reflection]");
        var particles = gsap.utils.toArray("[data-scene-particle]");
        var captions = gsap.utils.toArray("[data-hero-caption]");
        var motes = gsap.utils.toArray("[data-hero-mote]");
        if (!hero || !product || !copy || !lid) return;

        gsap.defaults({ force3D: true });

        /* Giriş: yüklemede sinematik belirme */
        var entrance = gsap.fromTo(
          product,
          { autoAlpha: 0, y: 110, scale: 0.88 },
          {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 1.5,
            ease: "power3.out",
            delay: 0.85,
          }
        );

        /* Ortam zerrecikleri: sonsuz, sakin salınım */
        motes.forEach(function (mote, index) {
          gsap.to(mote, {
            opacity: 0.16 + (index % 3) * 0.07,
            duration: 2,
            delay: 1.2 + index * 0.25,
            ease: "power1.out",
          });
          gsap.to(mote, {
            y: (index % 2 === 0 ? -1 : 1) * (20 + (index % 4) * 7),
            x: ((index % 3) - 1) * 12,
            duration: 7 + (index % 5) * 1.6,
            yoyo: true,
            repeat: -1,
            ease: "sine.inOut",
            delay: index * 0.3,
          });
        });

        /* Kaydırma daveti: nokta ince çizgide sonsuza dek süzülür */
        if (cueDot) {
          gsap.fromTo(
            cueDot,
            { y: -14, opacity: 0 },
            {
              y: 42,
              opacity: 1,
              duration: 1.6,
              repeat: -1,
              repeatDelay: 0.5,
              ease: "power1.inOut",
            }
          );
        }

        /* Mouse parallax: perspektif eğim + katmanlı derinlik (desktop) */
        if (desktop && sceneRoot) {
          var drift = function (target, prop, duration) {
            return target
              ? gsap.quickTo(target, prop, {
                  duration: duration,
                  ease: "power3.out",
                })
              : null;
          };

          var tiltX = drift(sceneRoot, "rotationX", 0.9);
          var tiltY = drift(sceneRoot, "rotationY", 0.9);
          var glowX = drift(glow, "x", 1.4);
          var glowY = drift(glow, "y", 1.4);
          var reflectionX = drift(reflection, "x", 1.1);

          var onPointerMove = function (event) {
            var nx = (event.clientX / window.innerWidth) * 2 - 1;
            var ny = (event.clientY / window.innerHeight) * 2 - 1;
            if (tiltX) tiltX(ny * -2.8);
            if (tiltY) tiltY(nx * 3.5);
            if (glowX) glowX(nx * -22);
            if (glowY) glowY(ny * -14);
            if (reflectionX) reflectionX(nx * 16);
          };

          window.addEventListener("pointermove", onPointerMove, {
            passive: true,
          });
          ctx.add(function () {
            return function () {
              window.removeEventListener("pointermove", onPointerMove);
            };
          });
        }

        /* Bölüm girişleri: pinlenen hero altında tek seferlik fade-up */
        gsap.utils.toArray("[data-reveal]").forEach(function (element) {
          gsap.fromTo(
            element,
            { autoAlpha: 0, y: 48 },
            {
              autoAlpha: 1,
              y: 0,
              duration: 1.1,
              ease: "power3.out",
              scrollTrigger: { trigger: element, start: "top 86%", once: true },
            }
          );
        });

        /* Ana scrub timeline: 10 birim = %100 ilerleme */
        var tl = gsap.timeline({
          defaults: { ease: "power2.inOut" },
          scrollTrigger: {
            trigger: hero,
            start: "top top",
            end: desktop ? "+=380%" : "+=260%",
            pin: true,
            scrub: 0.7,
            anticipatePin: 1,
            invalidateOnRefresh: true,
            onUpdate: function (self) {
              if (self.progress > 0.01 && entrance.isActive()) {
                entrance.progress(1).kill();
              }
            },
          },
        });

        /* %0–18 — metin geri çekilir, kamera kavanoza yerleşir */
        tl.to(
          copy,
          {
            autoAlpha: 0,
            y: -90,
            scale: 0.96,
            duration: 1.4,
            ease: "power1.in",
          },
          0
        );
        if (cue) {
          tl.to(cue, { autoAlpha: 0, duration: 0.5, ease: "power1.in" }, 0);
        }
        tl.to(
          product,
          {
            y: desktop ? "-44vh" : "-22vh",
            scale: desktop ? 1.24 : 1.08,
            duration: 2,
            ease: "power1.inOut",
          },
          0
        );

        /* Yumuşak ışık süpürmesi */
        if (sweep) {
          tl.fromTo(
            sweep,
            { xPercent: 0, autoAlpha: 0 },
            {
              xPercent: desktop ? 420 : 320,
              autoAlpha: 0.5,
              duration: 2.6,
              ease: "sine.inOut",
            },
            0.6
          );
          tl.to(sweep, { autoAlpha: 0, duration: 0.6, ease: "power1.in" }, 2.8);
        }

        /* Yan başlıklar — ilk üç sırayla, sonra sol+sağ güven çifti birlikte */
        captions.forEach(function (caption, index) {
          var at = index < 3 ? 1.6 + index * 1.5 : 5.9;
          var hold = index < 3 ? 1.0 : 1.35;
          tl.fromTo(
            caption,
            { autoAlpha: 0, y: 44 },
            { autoAlpha: 1, y: 0, duration: 0.5, ease: "power2.out" },
            at
          );
          tl.to(
            caption,
            { autoAlpha: 0, y: -44, duration: 0.45, ease: "power2.in" },
            at + hold
          );
        });

        /* %20 — kapak kalkmaya başlar */
        tl.to(lid, { yPercent: -13, duration: 1, ease: "power2.out" }, 2);

        /* %30 — kapak döner */
        tl.to(
          lid,
          { rotation: 12, yPercent: -30, duration: 1, ease: "sine.inOut" },
          3
        );

        /* %40 — kapak açılır: doğal bir yayla yukarı savrulur */
        tl.to(
          lid,
          {
            keyframes: [
              { yPercent: -68, xPercent: 12, rotation: 24, duration: 0.55 },
              { yPercent: -115, xPercent: 27, rotation: 36, duration: 0.65 },
            ],
            duration: 1.2,
            ease: "power2.inOut",
          },
          4
        );
        /* Motion blur hissi — sadece zirve hızda fısıltı kadar blur */
        tl.fromTo(
          lid,
          { filter: "blur(0px)" },
          { filter: "blur(2.5px)", duration: 0.5, ease: "power1.in" },
          4.2
        );
        tl.to(
          lid,
          { filter: "blur(0px)", duration: 0.45, ease: "power1.out" },
          4.75
        );
        tl.to(lid, { autoAlpha: 0, duration: 0.7, ease: "power1.in" }, 5.3);

        /* %60 — açık kavanozdan zerrecikler yükselir */
        if (particles.length) {
          tl.fromTo(
            particles,
            { autoAlpha: 0, y: 24, scale: 0.5 },
            {
              autoAlpha: 1,
              y: -70,
              scale: 1,
              duration: 1.5,
              stagger: 0.07,
              ease: "sine.out",
            },
            6
          );
          tl.to(
            particles,
            {
              autoAlpha: 0,
              y: -130,
              duration: 0.9,
              stagger: 0.05,
              ease: "sine.in",
            },
            7.4
          );
        }

        /* %60 — ürünün arkasında yumuşak parlama */
        if (glow) {
          tl.to(
            glow,
            { opacity: 1, scale: 1.12, duration: 1.2, ease: "sine.inOut" },
            6
          );
        }

        /* %70 — kamera yaklaşır */
        tl.to(
          product,
          {
            scale: desktop ? 1.52 : 1.26,
            y: desktop ? "-51vh" : "-26vh",
            duration: 1.5,
            ease: "power2.inOut",
          },
          7
        );
        if (shadow) {
          tl.to(
            shadow,
            { scaleX: 1.18, opacity: 0.6, duration: 1.5, ease: "power2.inOut" },
            7
          );
        }
        if (glow) {
          tl.to(glow, { yPercent: 7, duration: 1.5, ease: "power1.inOut" }, 7);
        }

        /* %80–100 — ürün yavaşça döner */
        tl.to(product, { rotation: 3.2, duration: 2, ease: "sine.inOut" }, 8);
      }
    );
  }

  /* ---- KVKK çerez bildirimi (piksel/analytics öncesi) ---- */
  function initCookieConsent() {
    try {
      if (localStorage.getItem("drsnail-cookie-consent")) return;
    } catch (e) {
      /* private mode */
    }
    if (document.getElementById("ds-cookie-consent")) return;

    var bar = document.createElement("div");
    bar.id = "ds-cookie-consent";
    bar.setAttribute("role", "dialog");
    bar.setAttribute("aria-label", "Çerez bildirimi");
    bar.style.cssText =
      "position:fixed;inset-inline:0;bottom:0;z-index:80;border-top:1px solid rgba(216,201,180,.45);" +
      "background:rgba(250,247,242,.96);padding:16px 20px;box-shadow:0 4px 12px rgba(61,52,40,.06),0 24px 64px rgba(61,52,40,.12);" +
      "backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);";
    bar.innerHTML =
      '<div style="max-width:64rem;margin:0 auto;display:flex;flex-wrap:wrap;gap:16px;align-items:center;justify-content:space-between;">' +
      '<p style="margin:0;font-size:14px;line-height:1.55;color:rgba(61,52,40,.8);max-width:40rem;">' +
      "Deneyimi iyileştirmek ve reklam performansını ölçmek için çerezler kullanıyoruz. " +
      '<a href="/policies/privacy-policy" style="text-decoration:underline;text-underline-offset:2px;color:inherit;">Gizlilik politikası</a>' +
      "</p>" +
      '<div style="display:flex;align-items:center;gap:20px;flex-shrink:0;">' +
      '<button type="button" data-ds-cookie="decline" style="background:none;border:0;padding:0;font-size:14px;color:rgba(61,52,40,.55);cursor:pointer;">Reddet</button>' +
      '<button type="button" data-ds-cookie="accept" style="background:#3d3428;color:#faf7f2;border:0;padding:10px 20px;font-size:14px;font-weight:500;cursor:pointer;">Kabul et</button>' +
      "</div></div>";

    function dismiss(value) {
      try {
        localStorage.setItem("drsnail-cookie-consent", value);
      } catch (e) {}
      bar.remove();
    }
    bar.querySelector('[data-ds-cookie="accept"]').addEventListener("click", function () {
      dismiss("accepted");
    });
    bar.querySelector('[data-ds-cookie="decline"]').addEventListener("click", function () {
      dismiss("declined");
    });
    document.body.appendChild(bar);
  }

  function boot() {
    init();
    initCookieConsent();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
